import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyBkhjzj5v9IMgZLOpXh-zlrXa0Z6CD1t9w",
  authDomain: "rotas-a59f1.firebaseapp.com",
  databaseURL: "https://rotas-a59f1-default-rtdb.firebaseio.com",
  projectId: "rotas-a59f1",
  storageBucket: "rotas-a59f1.firebasestorage.app",
  messagingSenderId: "630310560038",
  appId: "1:630310560038:web:11a00cdfd50d5245f7e1e7",
  measurementId: "G-32J2JMYFSZ"
};

const app = initializeApp(firebaseConfig);

// Exportações nomeadas para garantir compatibilidade com os outros arquivos
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
